// Webpack Imports
import 'bootstrap';


( function ( $ ) {
	'use strict';

	// Focus Search if Searchform is empty
	/*$( '.search-form' ).on( 'submit', function ( e ) {
		var search = $( '#s' );
		if ( search.val().length < 1 ) {
			e.preventDefault();
			search.trigger( 'focus' );
		}
	} );*/
	$('.carousel').carousel(
		//{interval: 20000000}
	);
	$('.surmesure-carrousel').slick(
		{
			slidesToShow: 4,
  			slidesToScroll: 1,
  			arrows:true,
			dots:false,
  			autoplay: true,
  			autoplaySpeed: 3000,
  			centerMode: true,
  			responsive: [
		    {
		      breakpoint: 1200,
		      settings: {
		        slidesToShow: 3,
		        slidesToScroll: 1,
		        infinite: true
		      }
		    },
		    {
		      breakpoint: 992,
		      settings: {
		        slidesToShow: 2,
		        slidesToScroll: 1
		      }
		    },
		    {
		      breakpoint: 768,
		      settings: {
		        slidesToShow: 1,
		        slidesToScroll: 1
		      }
		    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]

  		}
	);
	$('.imagos').slick(
		{
		slidesToShow: 1,
  		slidesToScroll: 1,arrows:false,dots:true,
  		autoplay: true,
  			autoplaySpeed: 2000,
  		}
	);
	$('#slider_unos').slick(
		{
		slidesToShow: 1,
  		slidesToScroll: 1,arrows:false,dots:false,
		  fade:true,
  		autoplay: true,
  			autoplaySpeed: 7000,
			  speed:1000,
  		}
	);
	$('#slider_dos').slick(
		{
		slidesToShow: 1,
  		slidesToScroll: 1,arrows:false,dots:false,
		  fade:true,
  		autoplay: true,
  			autoplaySpeed: 9000,
			  speed:1000,
  		}
	);
	$('#slider_tres').slick(
		{
		slidesToShow: 1,
  		slidesToScroll: 1,arrows:false,dots:false,
		  fade:true,
  		autoplay: true,
  			autoplaySpeed: 5000,
			  speed:1000,
  		}
	);
	$('body').addClass('scroll-container');

}( jQuery ) );